export enum EcontextPaymentMethod {
    Stores = "econtext_stores",
    SevenEleven = "econtext_seven_eleven",
}

export const ECONTEXT_PAYMENT_METHODS = [
    EcontextPaymentMethod.Stores,
    EcontextPaymentMethod.SevenEleven,
] as const;

export const paymentMethodMap: { [key: string]: string } = {
    applepay: "Apple Pay",
    mc_applePay: "Apple Pay",
    googlepay: "Google Pay",
    mc: "Mastercard",
    visa: "Visa",
    amex: "American Express",
    rupay: "RuPay",
    diners: "Diners",
    discover: "Discover",
    maestro: "Maestro",
    cup: "UnionPay",
    jcb: "JCB",
    paypal: "PayPal",
    upi: "UPI",
    kcp_payco: "PayCo",
    kcp_naverpay: "NaverPay",
    kakaopay: "KakaoPay",
    kcp_banktransfer: "Bank Transfer",
    kcp_creditcard: "Credit Card",
    klarna_account: "Klarna",
    klarna_paynow: "Klarna",
    klarna: "Klarna",
    grabpay: "GrabPay",
    zip: "Zip",
    afterpaytouch: "Afterpay Touch",
    paypay: "PayPay",
    [EcontextPaymentMethod.Stores]: "Konbini Payment",
    amazon_pay: "Amazon Pay",
    blik: "BLIK",
    onlinebanking_pl: "Przelewy24",
    ideal: "iDEAL",
    dankort: "Dankort",
    mobilepay: "MobilePay",
    vipps: "Vipps",
    swish: "Swish",
};

export const cardPaymentKeys = new Set([
    "mc",
    "visa",
    "amex",
    "diners",
    "discover",
    "rupay",
    "maestro",
    "cup",
    "jcb",
]);

export const paymentMethodTypes = {
    ApplePay: "applepay",
    GooglePay: "googlepay",
};
